import { createFileRoute, notFound } from "@tanstack/react-router";
import { Vt } from "@relais/shared";
import { VtSubsectionPage } from "@relais/forms-ui";

export const Route = createFileRoute("/tasks/$taskId/render/vt/$section/$subsection")({
  component: VtStepRoute,
});

function VtStepRoute() {
  const { section, subsection } = Route.useParams();
  const step = Vt.findVtStep(section, subsection);
  if (!step) throw notFound();
  return <VtSubsectionPage step={step} />;
}
